'use client';

import dynamic from 'next/dynamic';

import type { CasesSliderType } from '../../../types/storyblok';

export const CasesSlider = dynamic<CasesSliderType>(async () => import('./CasesSliderInner'), { ssr: true });
